export const COUNTRIES = {
  AF: { name: 'Afghanistan', native: '‫افغانستان‬‎', emoji: '🇦🇫', tel: '93' },
  AL: { name: 'Albania', native: 'Shqipëri', emoji: '🇦🇱', tel: '355' },
  DZ: { name: 'Algeria', native: '‫الجزائر‬‎', emoji: '🇩🇿', tel: '213' },
  AS: { name: 'American Samoa', native: null, emoji: '🇦🇸', tel: '1684' },
  AD: { name: 'Andorra', native: null, emoji: '🇦🇩', tel: '376' },
  AO: { name: 'Angola', native: null, emoji: '🇦🇴', tel: '244' },
  AI: { name: 'Anguilla', native: null, emoji: '🇦🇮', tel: '1264' },
  AG: { name: 'Antigua and Barbuda', native: null, emoji: '🇦🇬', tel: '1268' },
  AR: { name: 'Argentina', native: null, emoji: '🇦🇷', tel: '54' },
  AM: { name: 'Armenia', native: 'Հայաստան', emoji: '🇦🇲', tel: '374' },
  AW: { name: 'Aruba', native: null, emoji: '🇦🇼', tel: '297' },
  AU: { name: 'Australia', native: null, emoji: '🇦🇺', tel: '61' },
  AT: { name: 'Austria', native: 'Österreich', emoji: '🇦🇹', tel: '43' },
  AZ: { name: 'Azerbaijan', native: 'Azərbaycan', emoji: '🇦🇿', tel: '994' },
  BS: { name: 'Bahamas', native: null, emoji: '🇧🇸', tel: '1242' },
  BH: { name: 'Bahrain', native: '‫البحرين‬‎', emoji: '🇧🇭', tel: '973' },
  BD: { name: 'Bangladesh', native: 'বাংলাদেশ', emoji: '🇧🇩', tel: '880' },
  BB: { name: 'Barbados', native: null, emoji: '🇧🇧', tel: '1246' },
  BY: { name: 'Belarus', native: 'Беларусь', emoji: '🇧🇾', tel: '375' },
  BE: { name: 'Belgium', native: 'België', emoji: '🇧🇪', tel: '32' },
  BZ: { name: 'Belize', native: null, emoji: '🇧🇿', tel: '501' },
  BJ: { name: 'Benin', native: 'Bénin', emoji: '🇧🇯', tel: '229' },
  BM: { name: 'Bermuda', native: null, emoji: '🇧🇲', tel: '1441' },
  BT: { name: 'Bhutan', native: 'འབྲུག', emoji: '🇧🇹', tel: '975' },
  BO: { name: 'Bolivia', native: null, emoji: '🇧🇴', tel: '591' },
  BA: { name: 'Bosnia and Herzegovina', native: 'Босна и Херцеговина', emoji: '🇧🇦', tel: '387' },
  BW: { name: 'Botswana', native: null, emoji: '🇧🇼', tel: '267' },
  BR: { name: 'Brazil', native: 'Brasil', emoji: '🇧🇷', tel: '55' },
  IO: { name: 'British Indian Ocean Territory', native: null, emoji: '🇮🇴', tel: '246' },
  VG: { name: 'British Virgin Islands', native: null, emoji: '🇻🇬', tel: '1284' },
  BN: { name: 'Brunei', native: null, emoji: '🇧🇳', tel: '673' },
  BG: { name: 'Bulgaria', native: 'България', emoji: '🇧🇬', tel: '359' },
  BF: { name: 'Burkina Faso', native: null, emoji: '🇧🇫', tel: '226' },
  BI: { name: 'Burundi', native: 'Uburundi', emoji: '🇧🇮', tel: '257' },
  KH: { name: 'Cambodia', native: 'កម្ពុជា', emoji: '🇰🇭', tel: '855' },
  CM: { name: 'Cameroon', native: 'Cameroun', emoji: '🇨🇲', tel: '237' },
  CA: { name: 'Canada', native: null, emoji: '🇨🇦', tel: '1' },
  CV: { name: 'Cape Verde', native: 'Kabu Verdi', emoji: '🇨🇻', tel: '238' },
  BQ: { name: 'Caribbean Netherlands', native: null, emoji: '🇧🇶', tel: '599' },
  KY: { name: 'Cayman Islands', native: null, emoji: '🇰🇾', tel: '1345' },
  CF: { name: 'Central African Republic', native: 'République centrafricaine', emoji: '🇨🇫', tel: '236' },
  TD: { name: 'Chad', native: 'Tchad', emoji: '🇹🇩', tel: '235' },
  CL: { name: 'Chile', native: null, emoji: '🇨🇱', tel: '56' },
  CN: { name: 'China', native: '中国', emoji: '🇨🇳', tel: '86' },
  CX: { name: 'Christmas Island', native: null, emoji: '🇨🇽', tel: '61' },
  CC: { name: 'Cocos', native: 'Keeling Islands', emoji: '🇨🇨', tel: '61' },
  CO: { name: 'Colombia', native: null, emoji: '🇨🇴', tel: '57' },
  KM: { name: 'Comoros', native: '‫جزر القمر‬‎', emoji: '🇰🇲', tel: '269' },
  CD: { name: 'Congo', native: 'DRC', emoji: '🇨🇩', tel: '243' },
  CG: { name: 'Congo', native: 'Republic', emoji: '🇨🇬', tel: '242' },
  CK: { name: 'Cook Islands', native: null, emoji: '🇨🇰', tel: '682' },
  CR: { name: 'Costa Rica', native: null, emoji: '🇨🇷', tel: '506' },
  CI: { name: 'Côte d’Ivoire', native: null, emoji: '🇨🇮', tel: '225' },
  HR: { name: 'Croatia', native: 'Hrvatska', emoji: '🇭🇷', tel: '385' },
  CU: { name: 'Cuba', native: null, emoji: '🇨🇺', tel: '53' },
  CW: { name: 'Curaçao', native: null, emoji: '🇨🇼', tel: '599' },
  CY: { name: 'Cyprus', native: 'Κύπρος', emoji: '🇨🇾', tel: '357' },
  CZ: { name: 'Czech Republic', native: 'Česká republika', emoji: '🇨🇿', tel: '420' },
  DK: { name: 'Denmark', native: 'Danmark', emoji: '🇩🇰', tel: '45' },
  DJ: { name: 'Djibouti', native: null, emoji: '🇩🇯', tel: '253' },
  DM: { name: 'Dominica', native: null, emoji: '🇩🇲', tel: '1767' },
  DO: { name: 'Dominican Republic', native: 'República Dominicana', emoji: '🇩🇴', tel: '1' },
  EC: { name: 'Ecuador', native: null, emoji: '🇪🇨', tel: '593' },
  EG: { name: 'Egypt', native: '‫مصر‬‎', emoji: '🇪🇬', tel: '20' },
  SV: { name: 'El Salvador', native: null, emoji: '🇸🇻', tel: '503' },
  GQ: { name: 'Equatorial Guinea', native: 'Guinea Ecuatorial', emoji: '🇬🇶', tel: '240' },
  ER: { name: 'Eritrea', native: null, emoji: '🇪🇷', tel: '291' },
  EE: { name: 'Estonia', native: 'Eesti', emoji: '🇪🇪', tel: '372' },
  ET: { name: 'Ethiopia', native: null, emoji: '🇪🇹', tel: '251' },
  FK: { name: 'Falkland Islands', native: 'Islas Malvinas', emoji: '🇫🇰', tel: '500' },
  FO: { name: 'Faroe Islands', native: 'Føroyar', emoji: '🇫🇴', tel: '298' },
  FJ: { name: 'Fiji', native: null, emoji: '🇫🇯', tel: '679' },
  FI: { name: 'Finland', native: 'Suomi', emoji: '🇫🇮', tel: '358' },
  FR: { name: 'France', native: null, emoji: '🇫🇷', tel: '33' },
  GF: { name: 'French Guiana', native: 'Guyane française', emoji: '🇬🇫', tel: '594' },
  PF: { name: 'French Polynesia', native: 'Polynésie française', emoji: '🇵🇫', tel: '689' },
  GA: { name: 'Gabon', native: null, emoji: '🇬🇦', tel: '241' },
  GM: { name: 'Gambia', native: null, emoji: '🇬🇲', tel: '220' },
  GE: { name: 'Georgia', native: 'საქართველო', emoji: '🇬🇪', tel: '995' },
  DE: { name: 'Germany', native: 'Deutschland', emoji: '🇩🇪', tel: '49' },
  GH: { name: 'Ghana', native: 'Gaana', emoji: '🇬🇭', tel: '233' },
  GI: { name: 'Gibraltar', native: null, emoji: '🇬🇮', tel: '350' },
  GR: { name: 'Greece', native: 'Ελλάδα', emoji: '🇬🇷', tel: '30' },
  GL: { name: 'Greenland', native: 'Kalaallit Nunaat', emoji: '🇬🇱', tel: '299' },
  GD: { name: 'Grenada', native: null, emoji: '🇬🇩', tel: '1473' },
  GP: { name: 'Guadeloupe', native: null, emoji: '🇬🇵', tel: '590' },
  GU: { name: 'Guam', native: null, emoji: '🇬🇺', tel: '1671' },
  GT: { name: 'Guatemala', native: null, emoji: '🇬🇹', tel: '502' },
  GG: { name: 'Guernsey', native: null, emoji: '🇬🇬', tel: '44' },
  GN: { name: 'Guinea', native: 'Guinée', emoji: '🇬🇳', tel: '224' },
  GW: { name: 'Guinea-Bissau', native: 'Guiné Bissau', emoji: '🇬🇼', tel: '245' },
  GY: { name: 'Guyana', native: null, emoji: '🇬🇾', tel: '592' },
  HT: { name: 'Haiti', native: null, emoji: '🇭🇹', tel: '509' },
  HN: { name: 'Honduras', native: null, emoji: '🇭🇳', tel: '504' },
  HK: { name: 'Hong Kong', native: '香港', emoji: '🇭🇰', tel: '852' },
  HU: { name: 'Hungary', native: 'Magyarország', emoji: '🇭🇺', tel: '36' },
  IS: { name: 'Iceland', native: 'Ísland', emoji: '🇮🇸', tel: '354' },
  IN: { name: 'India', native: 'भारत', emoji: '🇮🇳', tel: '91' },
  ID: { name: 'Indonesia', native: null, emoji: '🇮🇩', tel: '62' },
  IR: { name: 'Iran', native: '‫ایران‬‎', emoji: '🇮🇷', tel: '98' },
  IQ: { name: 'Iraq', native: '‫العراق‬‎', emoji: '🇮🇶', tel: '964' },
  IE: { name: 'Ireland', native: null, emoji: '🇮🇪', tel: '353' },
  IM: { name: 'Isle of Man', native: null, emoji: '🇮🇲', tel: '44' },
  IL: { name: 'Israel', native: '‫ישראל‬‎', emoji: '🇮🇱', tel: '972' },
  IT: { name: 'Italy', native: 'Italia', emoji: '🇮🇹', tel: '39' },
  JM: { name: 'Jamaica', native: null, emoji: '🇯🇲', tel: '1876' },
  JP: { name: 'Japan', native: '日本', emoji: '🇯🇵', tel: '81' },
  JE: { name: 'Jersey', native: null, emoji: '🇯🇪', tel: '44' },
  JO: { name: 'Jordan', native: '‫الأردن‬‎', emoji: '🇯🇴', tel: '962' },
  KZ: { name: 'Kazakhstan', native: 'Казахстан', emoji: '🇰🇿', tel: '7' },
  KE: { name: 'Kenya', native: null, emoji: '🇰🇪', tel: '254' },
  KI: { name: 'Kiribati', native: null, emoji: '🇰🇮', tel: '686' },
  KW: { name: 'Kuwait', native: '‫الكويت‬‎', emoji: '🇰🇼', tel: '965' },
  KG: { name: 'Kyrgyzstan', native: 'Кыргызстан', emoji: '🇰🇬', tel: '996' },
  LA: { name: 'Laos', native: 'ລາວ', emoji: '🇱🇦', tel: '856' },
  LV: { name: 'Latvia', native: 'Latvija', emoji: '🇱🇻', tel: '371' },
  LB: { name: 'Lebanon', native: '‫لبنان‬‎', emoji: '🇱🇧', tel: '961' },
  LS: { name: 'Lesotho', native: null, emoji: '🇱🇸', tel: '266' },
  LR: { name: 'Liberia', native: null, emoji: '🇱🇷', tel: '231' },
  LY: { name: 'Libya', native: '‫ليبيا‬‎', emoji: '🇱🇾', tel: '218' },
  LI: { name: 'Liechtenstein', native: null, emoji: '🇱🇮', tel: '423' },
  LT: { name: 'Lithuania', native: 'Lietuva', emoji: '🇱🇹', tel: '370' },
  LU: { name: 'Luxembourg', native: null, emoji: '🇱🇺', tel: '352' },
  MO: { name: 'Macau', native: '澳門', emoji: '🇲🇴', tel: '853' },
  MK: { name: 'Macedonia', native: 'FYROM', emoji: '🇲🇰', tel: '389' },
  MG: { name: 'Madagascar', native: 'Madagasikara', emoji: '🇲🇬', tel: '261' },
  MW: { name: 'Malawi', native: null, emoji: '🇲🇼', tel: '265' },
  MY: { name: 'Malaysia', native: null, emoji: '🇲🇾', tel: '60' },
  MV: { name: 'Maldives', native: null, emoji: '🇲🇻', tel: '960' },
  ML: { name: 'Mali', native: null, emoji: '🇲🇱', tel: '223' },
  MT: { name: 'Malta', native: null, emoji: '🇲🇹', tel: '356' },
  MH: { name: 'Marshall Islands', native: null, emoji: '🇲🇭', tel: '692' },
  MQ: { name: 'Martinique', native: null, emoji: '🇲🇶', tel: '596' },
  MR: { name: 'Mauritania', native: '‫موريتانيا‬‎', emoji: '🇲🇷', tel: '222' },
  MU: { name: 'Mauritius', native: 'Moris', emoji: '🇲🇺', tel: '230' },
  YT: { name: 'Mayotte', native: null, emoji: '🇾🇹', tel: '262' },
  MX: { name: 'Mexico', native: 'México', emoji: '🇲🇽', tel: '52' },
  FM: { name: 'Micronesia', native: null, emoji: '🇫🇲', tel: '691' },
  MD: { name: 'Moldova', native: 'Republica Moldova', emoji: '🇲🇩', tel: '373' },
  MC: { name: 'Monaco', native: null, emoji: '🇲🇨', tel: '377' },
  MN: { name: 'Mongolia', native: 'Монгол', emoji: '🇲🇳', tel: '976' },
  ME: { name: 'Montenegro', native: 'Crna Gora', emoji: '🇲🇪', tel: '382' },
  MS: { name: 'Montserrat', native: null, emoji: '🇲🇸', tel: '1664' },
  MA: { name: 'Morocco', native: '‫المغرب‬‎', emoji: '🇲🇦', tel: '212' },
  MZ: { name: 'Mozambique', native: 'Moçambique', emoji: '🇲🇿', tel: '258' },
  MM: { name: 'Myanmar', native: 'Burma', emoji: '🇲🇲', tel: '95' },
  NA: { name: 'Namibia', native: 'Namibië', emoji: '🇳🇦', tel: '264' },
  NR: { name: 'Nauru', native: null, emoji: '🇳🇷', tel: '674' },
  NP: { name: 'Nepal', native: 'नेपाल', emoji: '🇳🇵', tel: '977' },
  NL: { name: 'Netherlands', native: 'Nederland', emoji: '🇳🇱', tel: '31' },
  NC: { name: 'New Caledonia', native: 'Nouvelle-Calédonie', emoji: '🇳🇨', tel: '687' },
  NZ: { name: 'New Zealand', native: null, emoji: '🇳🇿', tel: '64' },
  NI: { name: 'Nicaragua', native: null, emoji: '🇳🇮', tel: '505' },
  NE: { name: 'Niger', native: 'Nijar', emoji: '🇳🇪', tel: '227' },
  NG: { name: 'Nigeria', native: null, emoji: '🇳🇬', tel: '234' },
  NU: { name: 'Niue', native: null, emoji: '🇳🇺', tel: '683' },
  NF: { name: 'Norfolk Island', native: null, emoji: '🇳🇫', tel: '672' },
  KP: { name: 'North Korea', native: '조선 민주주의 인민 공화국', emoji: '🇰🇵', tel: '850' },
  MP: { name: 'Northern Mariana Islands', native: null, emoji: '🇲🇵', tel: '1670' },
  NO: { name: 'Norway', native: 'Norge', emoji: '🇳🇴', tel: '47' },
  OM: { name: 'Oman', native: '‫عُمان‬‎', emoji: '🇴🇲', tel: '968' },
  PK: { name: 'Pakistan', native: '‫پاکستان‬‎', emoji: '🇵🇰', tel: '92' },
  PW: { name: 'Palau', native: null, emoji: '🇵🇼', tel: '680' },
  PS: { name: 'Palestine', native: '‫فلسطين‬‎', emoji: '🇵🇸', tel: '970' },
  PA: { name: 'Panama', native: 'Panamá', emoji: '🇵🇦', tel: '507' },
  PG: { name: 'Papua New Guinea', native: null, emoji: '🇵🇬', tel: '675' },
  PY: { name: 'Paraguay', native: null, emoji: '🇵🇾', tel: '595' },
  PE: { name: 'Peru', native: 'Perú', emoji: '🇵🇪', tel: '51' },
  PH: { name: 'Philippines', native: null, emoji: '🇵🇭', tel: '63' },
  PL: { name: 'Poland', native: 'Polska', emoji: '🇵🇱', tel: '48' },
  PT: { name: 'Portugal', native: null, emoji: '🇵🇹', tel: '351' },
  PR: { name: 'Puerto Rico', native: null, emoji: '🇵🇷', tel: '1' },
  QA: { name: 'Qatar', native: '‫قطر‬‎', emoji: '🇶🇦', tel: '974' },
  RE: { name: 'Réunion', native: 'La Réunion', emoji: '🇷🇪', tel: '262' },
  RO: { name: 'Romania', native: 'România', emoji: '🇷🇴', tel: '40' },
  RU: { name: 'Russia', native: 'Россия', emoji: '🇷🇺', tel: '7' },
  RW: { name: 'Rwanda', native: null, emoji: '🇷🇼', tel: '250' },
  BL: { name: 'Saint Barthélemy', native: 'Saint-Barthélemy', emoji: '🇧🇱', tel: '590' },
  SH: { name: 'Saint Helena', native: null, emoji: '🇸🇭', tel: '290' },
  KN: { name: 'Saint Kitts and Nevis', native: null, emoji: '🇰🇳', tel: '1869' },
  LC: { name: 'Saint Lucia', native: null, emoji: '🇱🇨', tel: '1758' },
  MF: { name: 'Saint Martin', native: 'Saint-Martin', emoji: '🇲🇫', tel: '590' },
  PM: { name: 'Saint Pierre and Miquelon', native: 'Saint-Pierre-et-Miquelon', emoji: '🇵🇲', tel: '508' },
  VC: { name: 'Saint Vincent and the Grenadines', native: null, emoji: '🇻🇨', tel: '1784' },
  WS: { name: 'Samoa', native: null, emoji: '🇼🇸', tel: '685' },
  SM: { name: 'San Marino', native: null, emoji: '🇸🇲', tel: '378' },
  ST: { name: 'São Tomé and Príncipe', native: 'São Tomé e Príncipe', emoji: '🇸🇹', tel: '239' },
  SA: { name: 'Saudi Arabia', native: '‫المملكة العربية السعودية‬‎', emoji: '🇸🇦', tel: '966' },
  SN: { name: 'Senegal', native: 'Sénégal', emoji: '🇸🇳', tel: '221' },
  RS: { name: 'Serbia', native: 'Србија', emoji: '🇷🇸', tel: '381' },
  SC: { name: 'Seychelles', native: null, emoji: '🇸🇨', tel: '248' },
  SL: { name: 'Sierra Leone', native: null, emoji: '🇸🇱', tel: '232' },
  SG: { name: 'Singapore', native: null, emoji: '🇸🇬', tel: '65' },
  SX: { name: 'Sint Maarten', native: null, emoji: '🇸🇽', tel: '1721' },
  SK: { name: 'Slovakia', native: 'Slovensko', emoji: '🇸🇰', tel: '421' },
  SI: { name: 'Slovenia', native: 'Slovenija', emoji: '🇸🇮', tel: '386' },
  SB: { name: 'Solomon Islands', native: null, emoji: '🇸🇧', tel: '677' },
  SO: { name: 'Somalia', native: 'Soomaaliya', emoji: '🇸🇴', tel: '252' },
  ZA: { name: 'South Africa', native: null, emoji: '🇿🇦', tel: '27' },
  KR: { name: 'South Korea', native: '대한민국', emoji: '🇰🇷', tel: '82' },
  SS: { name: 'South Sudan', native: '‫جنوب السودان‬‎', emoji: '🇸🇸', tel: '211' },
  ES: { name: 'Spain', native: 'España', emoji: '🇪🇸', tel: '34' },
  LK: { name: 'Sri Lanka', native: 'ශ්‍රී ලංකාව', emoji: '🇱🇰', tel: '94' },
  SD: { name: 'Sudan', native: '‫السودان‬‎', emoji: '🇸🇩', tel: '249' },
  SR: { name: 'Suriname', native: null, emoji: '🇸🇷', tel: '597' },
  SJ: { name: 'Svalbard and Jan Mayen', native: null, emoji: '🇸🇯', tel: '47' },
  SZ: { name: 'Swaziland', native: null, emoji: '🇸🇿', tel: '268' },
  SE: { name: 'Sweden', native: 'Sverige', emoji: '🇸🇪', tel: '46' },
  CH: { name: 'Switzerland', native: 'Schweiz', emoji: '🇨🇭', tel: '41' },
  SY: { name: 'Syria', native: '‫سوريا‬‎', emoji: '🇸🇾', tel: '963' },
  TW: { name: 'Taiwan', native: '台灣', emoji: '🇹🇼', tel: '886' },
  TJ: { name: 'Tajikistan', native: null, emoji: '🇹🇯', tel: '992' },
  TZ: { name: 'Tanzania', native: null, emoji: '🇹🇿', tel: '255' },
  TH: { name: 'Thailand', native: 'ไทย', emoji: '🇹🇭', tel: '66' },
  TL: { name: 'Timor-Leste', native: null, emoji: '🇹🇱', tel: '670' },
  TG: { name: 'Togo', native: null, emoji: '🇹🇬', tel: '228' },
  TK: { name: 'Tokelau', native: null, emoji: '🇹🇰', tel: '690' },
  TO: { name: 'Tonga', native: null, emoji: '🇹🇴', tel: '676' },
  TT: { name: 'Trinidad and Tobago', native: null, emoji: '🇹🇹', tel: '1868' },
  TN: { name: 'Tunisia', native: '‫تونس‬‎', emoji: '🇹🇳', tel: '216' },
  TR: { name: 'Turkey', native: 'Türkiye', emoji: '🇹🇷', tel: '90' },
  TM: { name: 'Turkmenistan', native: null, emoji: '🇹🇲', tel: '993' },
  TC: { name: 'Turks and Caicos Islands', native: null, emoji: '🇹🇨', tel: '1649' },
  TV: { name: 'Tuvalu', native: null, emoji: '🇹🇻', tel: '688' },
  VI: { name: 'U.S. Virgin Islands', native: null, emoji: '🇻🇮', tel: '1340' },
  UG: { name: 'Uganda', native: null, emoji: '🇺🇬', tel: '256' },
  UA: { name: 'Ukraine', native: 'Україна', emoji: '🇺🇦', tel: '380' },
  AE: { name: 'United Arab Emirates', native: '‫الإمارات العربية المتحدة‬‎', emoji: '🇦🇪', tel: '971' },
  GB: { name: 'United Kingdom', native: null, emoji: '🇬🇧', tel: '44' },
  US: { name: 'United States', native: null, emoji: '🇺🇸', tel: '1' },
  UY: { name: 'Uruguay', native: null, emoji: '🇺🇾', tel: '598' },
  UZ: { name: 'Uzbekistan', native: 'Oʻzbekiston', emoji: '🇺🇿', tel: '998' },
  VU: { name: 'Vanuatu', native: null, emoji: '🇻🇺', tel: '678' },
  VA: { name: 'Vatican City', native: 'Città del Vaticano', emoji: '🇻🇦', tel: '39' },
  VE: { name: 'Venezuela', native: null, emoji: '🇻🇪', tel: '58' },
  VN: { name: 'Vietnam', native: 'Việt Nam', emoji: '🇻🇳', tel: '84' },
  WF: { name: 'Wallis and Futuna', native: null, emoji: '🇼🇫', tel: '681' },
  EH: { name: 'Western Sahara', native: '‫الصحراء الغربية‬‎', emoji: '🇪🇭', tel: '212' },
  YE: { name: 'Yemen', native: '‫اليمن‬‎', emoji: '🇾🇪', tel: '967' },
  ZM: { name: 'Zambia', native: null, emoji: '🇿🇲', tel: '260' },
  ZW: { name: 'Zimbabwe', native: null, emoji: '🇿🇼', tel: '263' },
  AX: { name: 'Åland Islands', native: null, emoji: '🇦🇽', tel: '358' }
};

export const COUNTRIES_ARR = [
  { code: 'AF', name: 'Afghanistan', native: '‫افغانستان‬‎', emoji: '🇦🇫', tel: '93' },
  { code: 'AL', name: 'Albania', native: 'Shqipëri', emoji: '🇦🇱', tel: '355' },
  { code: 'DZ', name: 'Algeria', native: '‫الجزائر‬‎', emoji: '🇩🇿', tel: '213' },
  { code: 'AS', name: 'American Samoa', native: null, emoji: '🇦🇸', tel: '1684' },
  { code: 'AD', name: 'Andorra', native: null, emoji: '🇦🇩', tel: '376' },
  { code: 'AO', name: 'Angola', native: null, emoji: '🇦🇴', tel: '244' },
  { code: 'AI', name: 'Anguilla', native: null, emoji: '🇦🇮', tel: '1264' },
  { code: 'AG', name: 'Antigua and Barbuda', native: null, emoji: '🇦🇬', tel: '1268' },
  { code: 'AR', name: 'Argentina', native: null, emoji: '🇦🇷', tel: '54' },
  { code: 'AM', name: 'Armenia', native: 'Հայաստան', emoji: '🇦🇲', tel: '374' },
  { code: 'AW', name: 'Aruba', native: null, emoji: '🇦🇼', tel: '297' },
  { code: 'AU', name: 'Australia', native: null, emoji: '🇦🇺', tel: '61' },
  { code: 'AT', name: 'Austria', native: 'Österreich', emoji: '🇦🇹', tel: '43' },
  { code: 'AZ', name: 'Azerbaijan', native: 'Azərbaycan', emoji: '🇦🇿', tel: '994' },
  { code: 'BS', name: 'Bahamas', native: null, emoji: '🇧🇸', tel: '1242' },
  { code: 'BH', name: 'Bahrain', native: '‫البحرين‬‎', emoji: '🇧🇭', tel: '973' },
  { code: 'BD', name: 'Bangladesh', native: 'বাংলাদেশ', emoji: '🇧🇩', tel: '880' },
  { code: 'BB', name: 'Barbados', native: null, emoji: '🇧🇧', tel: '1246' },
  { code: 'BY', name: 'Belarus', native: 'Беларусь', emoji: '🇧🇾', tel: '375' },
  { code: 'BE', name: 'Belgium', native: 'België', emoji: '🇧🇪', tel: '32' },
  { code: 'BZ', name: 'Belize', native: null, emoji: '🇧🇿', tel: '501' },
  { code: 'BJ', name: 'Benin', native: 'Bénin', emoji: '🇧🇯', tel: '229' },
  { code: 'BM', name: 'Bermuda', native: null, emoji: '🇧🇲', tel: '1441' },
  { code: 'BT', name: 'Bhutan', native: 'འབྲུག', emoji: '🇧🇹', tel: '975' },
  { code: 'BO', name: 'Bolivia', native: null, emoji: '🇧🇴', tel: '591' },
  { code: 'BA', name: 'Bosnia and Herzegovina', native: 'Босна и Херцеговина', emoji: '🇧🇦', tel: '387' },
  { code: 'BW', name: 'Botswana', native: null, emoji: '🇧🇼', tel: '267' },
  { code: 'BR', name: 'Brazil', native: 'Brasil', emoji: '🇧🇷', tel: '55' },
  { code: 'IO', name: 'British Indian Ocean Territory', native: null, emoji: '🇮🇴', tel: '246' },
  { code: 'VG', name: 'British Virgin Islands', native: null, emoji: '🇻🇬', tel: '1284' },
  { code: 'BN', name: 'Brunei', native: null, emoji: '🇧🇳', tel: '673' },
  { code: 'BG', name: 'Bulgaria', native: 'България', emoji: '🇧🇬', tel: '359' },
  { code: 'BF', name: 'Burkina Faso', native: null, emoji: '🇧🇫', tel: '226' },
  { code: 'BI', name: 'Burundi', native: 'Uburundi', emoji: '🇧🇮', tel: '257' },
  { code: 'KH', name: 'Cambodia', native: 'កម្ពុជា', emoji: '🇰🇭', tel: '855' },
  { code: 'CM', name: 'Cameroon', native: 'Cameroun', emoji: '🇨🇲', tel: '237' },
  { code: 'CA', name: 'Canada', native: null, emoji: '🇨🇦', tel: '1' },
  { code: 'CV', name: 'Cape Verde', native: 'Kabu Verdi', emoji: '🇨🇻', tel: '238' },
  { code: 'BQ', name: 'Caribbean Netherlands', native: null, emoji: '🇧🇶', tel: '599' },
  { code: 'KY', name: 'Cayman Islands', native: null, emoji: '🇰🇾', tel: '1345' },
  { code: 'CF', name: 'Central African Republic', native: 'République centrafricaine', emoji: '🇨🇫', tel: '236' },
  { code: 'TD', name: 'Chad', native: 'Tchad', emoji: '🇹🇩', tel: '235' },
  { code: 'CL', name: 'Chile', native: null, emoji: '🇨🇱', tel: '56' },
  { code: 'CN', name: 'China', native: '中国', emoji: '🇨🇳', tel: '86' },
  { code: 'CX', name: 'Christmas Island', native: null, emoji: '🇨🇽', tel: '61' },
  { code: 'CC', name: 'Cocos', native: 'Keeling Islands', emoji: '🇨🇨', tel: '61' },
  { code: 'CO', name: 'Colombia', native: null, emoji: '🇨🇴', tel: '57' },
  { code: 'KM', name: 'Comoros', native: '‫جزر القمر‬‎', emoji: '🇰🇲', tel: '269' },
  { code: 'CD', name: 'Congo', native: 'DRC', emoji: '🇨🇩', tel: '243' },
  { code: 'CG', name: 'Congo', native: 'Republic', emoji: '🇨🇬', tel: '242' },
  { code: 'CK', name: 'Cook Islands', native: null, emoji: '🇨🇰', tel: '682' },
  { code: 'CR', name: 'Costa Rica', native: null, emoji: '🇨🇷', tel: '506' },
  { code: 'CI', name: 'Côte d’Ivoire', native: null, emoji: '🇨🇮', tel: '225' },
  { code: 'HR', name: 'Croatia', native: 'Hrvatska', emoji: '🇭🇷', tel: '385' },
  { code: 'CU', name: 'Cuba', native: null, emoji: '🇨🇺', tel: '53' },
  { code: 'CW', name: 'Curaçao', native: null, emoji: '🇨🇼', tel: '599' },
  { code: 'CY', name: 'Cyprus', native: 'Κύπρος', emoji: '🇨🇾', tel: '357' },
  { code: 'CZ', name: 'Czech Republic', native: 'Česká republika', emoji: '🇨🇿', tel: '420' },
  { code: 'DK', name: 'Denmark', native: 'Danmark', emoji: '🇩🇰', tel: '45' },
  { code: 'DJ', name: 'Djibouti', native: null, emoji: '🇩🇯', tel: '253' },
  { code: 'DM', name: 'Dominica', native: null, emoji: '🇩🇲', tel: '1767' },
  { code: 'DO', name: 'Dominican Republic', native: 'República Dominicana', emoji: '🇩🇴', tel: '1' },
  { code: 'EC', name: 'Ecuador', native: null, emoji: '🇪🇨', tel: '593' },
  { code: 'EG', name: 'Egypt', native: '‫مصر‬‎', emoji: '🇪🇬', tel: '20' },
  { code: 'SV', name: 'El Salvador', native: null, emoji: '🇸🇻', tel: '503' },
  { code: 'GQ', name: 'Equatorial Guinea', native: 'Guinea Ecuatorial', emoji: '🇬🇶', tel: '240' },
  { code: 'ER', name: 'Eritrea', native: null, emoji: '🇪🇷', tel: '291' },
  { code: 'EE', name: 'Estonia', native: 'Eesti', emoji: '🇪🇪', tel: '372' },
  { code: 'ET', name: 'Ethiopia', native: null, emoji: '🇪🇹', tel: '251' },
  { code: 'FK', name: 'Falkland Islands', native: 'Islas Malvinas', emoji: '🇫🇰', tel: '500' },
  { code: 'FO', name: 'Faroe Islands', native: 'Føroyar', emoji: '🇫🇴', tel: '298' },
  { code: 'FJ', name: 'Fiji', native: null, emoji: '🇫🇯', tel: '679' },
  { code: 'FI', name: 'Finland', native: 'Suomi', emoji: '🇫🇮', tel: '358' },
  { code: 'FR', name: 'France', native: null, emoji: '🇫🇷', tel: '33' },
  { code: 'GF', name: 'French Guiana', native: 'Guyane française', emoji: '🇬🇫', tel: '594' },
  { code: 'PF', name: 'French Polynesia', native: 'Polynésie française', emoji: '🇵🇫', tel: '689' },
  { code: 'GA', name: 'Gabon', native: null, emoji: '🇬🇦', tel: '241' },
  { code: 'GM', name: 'Gambia', native: null, emoji: '🇬🇲', tel: '220' },
  { code: 'GE', name: 'Georgia', native: 'საქართველო', emoji: '🇬🇪', tel: '995' },
  { code: 'DE', name: 'Germany', native: 'Deutschland', emoji: '🇩🇪', tel: '49' },
  { code: 'GH', name: 'Ghana', native: 'Gaana', emoji: '🇬🇭', tel: '233' },
  { code: 'GI', name: 'Gibraltar', native: null, emoji: '🇬🇮', tel: '350' },
  { code: 'GR', name: 'Greece', native: 'Ελλάδα', emoji: '🇬🇷', tel: '30' },
  { code: 'GL', name: 'Greenland', native: 'Kalaallit Nunaat', emoji: '🇬🇱', tel: '299' },
  { code: 'GD', name: 'Grenada', native: null, emoji: '🇬🇩', tel: '1473' },
  { code: 'GP', name: 'Guadeloupe', native: null, emoji: '🇬🇵', tel: '590' },
  { code: 'GU', name: 'Guam', native: null, emoji: '🇬🇺', tel: '1671' },
  { code: 'GT', name: 'Guatemala', native: null, emoji: '🇬🇹', tel: '502' },
  { code: 'GG', name: 'Guernsey', native: null, emoji: '🇬🇬', tel: '44' },
  { code: 'GN', name: 'Guinea', native: 'Guinée', emoji: '🇬🇳', tel: '224' },
  { code: 'GW', name: 'Guinea-Bissau', native: 'Guiné Bissau', emoji: '🇬🇼', tel: '245' },
  { code: 'GY', name: 'Guyana', native: null, emoji: '🇬🇾', tel: '592' },
  { code: 'HT', name: 'Haiti', native: null, emoji: '🇭🇹', tel: '509' },
  { code: 'HN', name: 'Honduras', native: null, emoji: '🇭🇳', tel: '504' },
  { code: 'HK', name: 'Hong Kong', native: '香港', emoji: '🇭🇰', tel: '852' },
  { code: 'HU', name: 'Hungary', native: 'Magyarország', emoji: '🇭🇺', tel: '36' },
  { code: 'IS', name: 'Iceland', native: 'Ísland', emoji: '🇮🇸', tel: '354' },
  { code: 'IN', name: 'India', native: 'भारत', emoji: '🇮🇳', tel: '91' },
  { code: 'ID', name: 'Indonesia', native: null, emoji: '🇮🇩', tel: '62' },
  { code: 'IR', name: 'Iran', native: '‫ایران‬‎', emoji: '🇮🇷', tel: '98' },
  { code: 'IQ', name: 'Iraq', native: '‫العراق‬‎', emoji: '🇮🇶', tel: '964' },
  { code: 'IE', name: 'Ireland', native: null, emoji: '🇮🇪', tel: '353' },
  { code: 'IM', name: 'Isle of Man', native: null, emoji: '🇮🇲', tel: '44' },
  { code: 'IL', name: 'Israel', native: '‫ישראל‬‎', emoji: '🇮🇱', tel: '972' },
  { code: 'IT', name: 'Italy', native: 'Italia', emoji: '🇮🇹', tel: '39' },
  { code: 'JM', name: 'Jamaica', native: null, emoji: '🇯🇲', tel: '1876' },
  { code: 'JP', name: 'Japan', native: '日本', emoji: '🇯🇵', tel: '81' },
  { code: 'JE', name: 'Jersey', native: null, emoji: '🇯🇪', tel: '44' },
  { code: 'JO', name: 'Jordan', native: '‫الأردن‬‎', emoji: '🇯🇴', tel: '962' },
  { code: 'KZ', name: 'Kazakhstan', native: 'Казахстан', emoji: '🇰🇿', tel: '7' },
  { code: 'KE', name: 'Kenya', native: null, emoji: '🇰🇪', tel: '254' },
  { code: 'KI', name: 'Kiribati', native: null, emoji: '🇰🇮', tel: '686' },
  { code: 'KW', name: 'Kuwait', native: '‫الكويت‬‎', emoji: '🇰🇼', tel: '965' },
  { code: 'KG', name: 'Kyrgyzstan', native: 'Кыргызстан', emoji: '🇰🇬', tel: '996' },
  { code: 'LA', name: 'Laos', native: 'ລາວ', emoji: '🇱🇦', tel: '856' },
  { code: 'LV', name: 'Latvia', native: 'Latvija', emoji: '🇱🇻', tel: '371' },
  { code: 'LB', name: 'Lebanon', native: '‫لبنان‬‎', emoji: '🇱🇧', tel: '961' },
  { code: 'LS', name: 'Lesotho', native: null, emoji: '🇱🇸', tel: '266' },
  { code: 'LR', name: 'Liberia', native: null, emoji: '🇱🇷', tel: '231' },
  { code: 'LY', name: 'Libya', native: '‫ليبيا‬‎', emoji: '🇱🇾', tel: '218' },
  { code: 'LI', name: 'Liechtenstein', native: null, emoji: '🇱🇮', tel: '423' },
  { code: 'LT', name: 'Lithuania', native: 'Lietuva', emoji: '🇱🇹', tel: '370' },
  { code: 'LU', name: 'Luxembourg', native: null, emoji: '🇱🇺', tel: '352' },
  { code: 'MO', name: 'Macau', native: '澳門', emoji: '🇲🇴', tel: '853' },
  { code: 'MK', name: 'Macedonia', native: 'FYROM', emoji: '🇲🇰', tel: '389' },
  { code: 'MG', name: 'Madagascar', native: 'Madagasikara', emoji: '🇲🇬', tel: '261' },
  { code: 'MW', name: 'Malawi', native: null, emoji: '🇲🇼', tel: '265' },
  { code: 'MY', name: 'Malaysia', native: null, emoji: '🇲🇾', tel: '60' },
  { code: 'MV', name: 'Maldives', native: null, emoji: '🇲🇻', tel: '960' },
  { code: 'ML', name: 'Mali', native: null, emoji: '🇲🇱', tel: '223' },
  { code: 'MT', name: 'Malta', native: null, emoji: '🇲🇹', tel: '356' },
  { code: 'MH', name: 'Marshall Islands', native: null, emoji: '🇲🇭', tel: '692' },
  { code: 'MQ', name: 'Martinique', native: null, emoji: '🇲🇶', tel: '596' },
  { code: 'MR', name: 'Mauritania', native: '‫موريتانيا‬‎', emoji: '🇲🇷', tel: '222' },
  { code: 'MU', name: 'Mauritius', native: 'Moris', emoji: '🇲🇺', tel: '230' },
  { code: 'YT', name: 'Mayotte', native: null, emoji: '🇾🇹', tel: '262' },
  { code: 'MX', name: 'Mexico', native: 'México', emoji: '🇲🇽', tel: '52' },
  { code: 'FM', name: 'Micronesia', native: null, emoji: '🇫🇲', tel: '691' },
  { code: 'MD', name: 'Moldova', native: 'Republica Moldova', emoji: '🇲🇩', tel: '373' },
  { code: 'MC', name: 'Monaco', native: null, emoji: '🇲🇨', tel: '377' },
  { code: 'MN', name: 'Mongolia', native: 'Монгол', emoji: '🇲🇳', tel: '976' },
  { code: 'ME', name: 'Montenegro', native: 'Crna Gora', emoji: '🇲🇪', tel: '382' },
  { code: 'MS', name: 'Montserrat', native: null, emoji: '🇲🇸', tel: '1664' },
  { code: 'MA', name: 'Morocco', native: '‫المغرب‬‎', emoji: '🇲🇦', tel: '212' },
  { code: 'MZ', name: 'Mozambique', native: 'Moçambique', emoji: '🇲🇿', tel: '258' },
  { code: 'MM', name: 'Myanmar', native: 'Burma', emoji: '🇲🇲', tel: '95' },
  { code: 'NA', name: 'Namibia', native: 'Namibië', emoji: '🇳🇦', tel: '264' },
  { code: 'NR', name: 'Nauru', native: null, emoji: '🇳🇷', tel: '674' },
  { code: 'NP', name: 'Nepal', native: 'नेपाल', emoji: '🇳🇵', tel: '977' },
  { code: 'NL', name: 'Netherlands', native: 'Nederland', emoji: '🇳🇱', tel: '31' },
  { code: 'NC', name: 'New Caledonia', native: 'Nouvelle-Calédonie', emoji: '🇳🇨', tel: '687' },
  { code: 'NZ', name: 'New Zealand', native: null, emoji: '🇳🇿', tel: '64' },
  { code: 'NI', name: 'Nicaragua', native: null, emoji: '🇳🇮', tel: '505' },
  { code: 'NE', name: 'Niger', native: 'Nijar', emoji: '🇳🇪', tel: '227' },
  { code: 'NG', name: 'Nigeria', native: null, emoji: '🇳🇬', tel: '234' },
  { code: 'NU', name: 'Niue', native: null, emoji: '🇳🇺', tel: '683' },
  { code: 'NF', name: 'Norfolk Island', native: null, emoji: '🇳🇫', tel: '672' },
  { code: 'KP', name: 'North Korea', native: '조선 민주주의 인민 공화국', emoji: '🇰🇵', tel: '850' },
  { code: 'MP', name: 'Northern Mariana Islands', native: null, emoji: '🇲🇵', tel: '1670' },
  { code: 'NO', name: 'Norway', native: 'Norge', emoji: '🇳🇴', tel: '47' },
  { code: 'OM', name: 'Oman', native: '‫عُمان‬‎', emoji: '🇴🇲', tel: '968' },
  { code: 'PK', name: 'Pakistan', native: '‫پاکستان‬‎', emoji: '🇵🇰', tel: '92' },
  { code: 'PW', name: 'Palau', native: null, emoji: '🇵🇼', tel: '680' },
  { code: 'PS', name: 'Palestine', native: '‫فلسطين‬‎', emoji: '🇵🇸', tel: '970' },
  { code: 'PA', name: 'Panama', native: 'Panamá', emoji: '🇵🇦', tel: '507' },
  { code: 'PG', name: 'Papua New Guinea', native: null, emoji: '🇵🇬', tel: '675' },
  { code: 'PY', name: 'Paraguay', native: null, emoji: '🇵🇾', tel: '595' },
  { code: 'PE', name: 'Peru', native: 'Perú', emoji: '🇵🇪', tel: '51' },
  { code: 'PH', name: 'Philippines', native: null, emoji: '🇵🇭', tel: '63' },
  { code: 'PL', name: 'Poland', native: 'Polska', emoji: '🇵🇱', tel: '48' },
  { code: 'PT', name: 'Portugal', native: null, emoji: '🇵🇹', tel: '351' },
  { code: 'PR', name: 'Puerto Rico', native: null, emoji: '🇵🇷', tel: '1' },
  { code: 'QA', name: 'Qatar', native: '‫قطر‬‎', emoji: '🇶🇦', tel: '974' },
  { code: 'RE', name: 'Réunion', native: 'La Réunion', emoji: '🇷🇪', tel: '262' },
  { code: 'RO', name: 'Romania', native: 'România', emoji: '🇷🇴', tel: '40' },
  { code: 'RU', name: 'Russia', native: 'Россия', emoji: '🇷🇺', tel: '7' },
  { code: 'RW', name: 'Rwanda', native: null, emoji: '🇷🇼', tel: '250' },
  { code: 'BL', name: 'Saint Barthélemy', native: 'Saint-Barthélemy', emoji: '🇧🇱', tel: '590' },
  { code: 'SH', name: 'Saint Helena', native: null, emoji: '🇸🇭', tel: '290' },
  { code: 'KN', name: 'Saint Kitts and Nevis', native: null, emoji: '🇰🇳', tel: '1869' },
  { code: 'LC', name: 'Saint Lucia', native: null, emoji: '🇱🇨', tel: '1758' },
  { code: 'MF', name: 'Saint Martin', native: 'Saint-Martin', emoji: '🇲🇫', tel: '590' },
  { code: 'PM', name: 'Saint Pierre and Miquelon', native: 'Saint-Pierre-et-Miquelon', emoji: '🇵🇲', tel: '508' },
  { code: 'VC', name: 'Saint Vincent and the Grenadines', native: null, emoji: '🇻🇨', tel: '1784' },
  { code: 'WS', name: 'Samoa', native: null, emoji: '🇼🇸', tel: '685' },
  { code: 'SM', name: 'San Marino', native: null, emoji: '🇸🇲', tel: '378' },
  { code: 'ST', name: 'São Tomé and Príncipe', native: 'São Tomé e Príncipe', emoji: '🇸🇹', tel: '239' },
  { code: 'SA', name: 'Saudi Arabia', native: '‫المملكة العربية السعودية‬‎', emoji: '🇸🇦', tel: '966' },
  { code: 'SN', name: 'Senegal', native: 'Sénégal', emoji: '🇸🇳', tel: '221' },
  { code: 'RS', name: 'Serbia', native: 'Србија', emoji: '🇷🇸', tel: '381' },
  { code: 'SC', name: 'Seychelles', native: null, emoji: '🇸🇨', tel: '248' },
  { code: 'SL', name: 'Sierra Leone', native: null, emoji: '🇸🇱', tel: '232' },
  { code: 'SG', name: 'Singapore', native: null, emoji: '🇸🇬', tel: '65' },
  { code: 'SX', name: 'Sint Maarten', native: null, emoji: '🇸🇽', tel: '1721' },
  { code: 'SK', name: 'Slovakia', native: 'Slovensko', emoji: '🇸🇰', tel: '421' },
  { code: 'SI', name: 'Slovenia', native: 'Slovenija', emoji: '🇸🇮', tel: '386' },
  { code: 'SB', name: 'Solomon Islands', native: null, emoji: '🇸🇧', tel: '677' },
  { code: 'SO', name: 'Somalia', native: 'Soomaaliya', emoji: '🇸🇴', tel: '252' },
  { code: 'ZA', name: 'South Africa', native: null, emoji: '🇿🇦', tel: '27' },
  { code: 'KR', name: 'South Korea', native: '대한민국', emoji: '🇰🇷', tel: '82' },
  { code: 'SS', name: 'South Sudan', native: '‫جنوب السودان‬‎', emoji: '🇸🇸', tel: '211' },
  { code: 'ES', name: 'Spain', native: 'España', emoji: '🇪🇸', tel: '34' },
  { code: 'LK', name: 'Sri Lanka', native: 'ශ්‍රී ලංකාව', emoji: '🇱🇰', tel: '94' },
  { code: 'SD', name: 'Sudan', native: '‫السودان‬‎', emoji: '🇸🇩', tel: '249' },
  { code: 'SR', name: 'Suriname', native: null, emoji: '🇸🇷', tel: '597' },
  { code: 'SJ', name: 'Svalbard and Jan Mayen', native: null, emoji: '🇸🇯', tel: '47' },
  { code: 'SZ', name: 'Swaziland', native: null, emoji: '🇸🇿', tel: '268' },
  { code: 'SE', name: 'Sweden', native: 'Sverige', emoji: '🇸🇪', tel: '46' },
  { code: 'CH', name: 'Switzerland', native: 'Schweiz', emoji: '🇨🇭', tel: '41' },
  { code: 'SY', name: 'Syria', native: '‫سوريا‬‎', emoji: '🇸🇾', tel: '963' },
  { code: 'TW', name: 'Taiwan', native: '台灣', emoji: '🇹🇼', tel: '886' },
  { code: 'TJ', name: 'Tajikistan', native: null, emoji: '🇹🇯', tel: '992' },
  { code: 'TZ', name: 'Tanzania', native: null, emoji: '🇹🇿', tel: '255' },
  { code: 'TH', name: 'Thailand', native: 'ไทย', emoji: '🇹🇭', tel: '66' },
  { code: 'TL', name: 'Timor-Leste', native: null, emoji: '🇹🇱', tel: '670' },
  { code: 'TG', name: 'Togo', native: null, emoji: '🇹🇬', tel: '228' },
  { code: 'TK', name: 'Tokelau', native: null, emoji: '🇹🇰', tel: '690' },
  { code: 'TO', name: 'Tonga', native: null, emoji: '🇹🇴', tel: '676' },
  { code: 'TT', name: 'Trinidad and Tobago', native: null, emoji: '🇹🇹', tel: '1868' },
  { code: 'TN', name: 'Tunisia', native: '‫تونس‬‎', emoji: '🇹🇳', tel: '216' },
  { code: 'TR', name: 'Turkey', native: 'Türkiye', emoji: '🇹🇷', tel: '90' },
  { code: 'TM', name: 'Turkmenistan', native: null, emoji: '🇹🇲', tel: '993' },
  { code: 'TC', name: 'Turks and Caicos Islands', native: null, emoji: '🇹🇨', tel: '1649' },
  { code: 'TV', name: 'Tuvalu', native: null, emoji: '🇹🇻', tel: '688' },
  { code: 'VI', name: 'U.S. Virgin Islands', native: null, emoji: '🇻🇮', tel: '1340' },
  { code: 'UG', name: 'Uganda', native: null, emoji: '🇺🇬', tel: '256' },
  { code: 'UA', name: 'Ukraine', native: 'Україна', emoji: '🇺🇦', tel: '380' },
  { code: 'AE', name: 'United Arab Emirates', native: '‫الإمارات العربية المتحدة‬‎', emoji: '🇦🇪', tel: '971' },
  { code: 'GB', name: 'United Kingdom', native: null, emoji: '🇬🇧', tel: '44' },
  { code: 'US', name: 'United States', native: null, emoji: '🇺🇸', tel: '1' },
  { code: 'UY', name: 'Uruguay', native: null, emoji: '🇺🇾', tel: '598' },
  { code: 'UZ', name: 'Uzbekistan', native: 'Oʻzbekiston', emoji: '🇺🇿', tel: '998' },
  { code: 'VU', name: 'Vanuatu', native: null, emoji: '🇻🇺', tel: '678' },
  { code: 'VA', name: 'Vatican City', native: 'Città del Vaticano', emoji: '🇻🇦', tel: '39' },
  { code: 'VE', name: 'Venezuela', native: null, emoji: '🇻🇪', tel: '58' },
  { code: 'VN', name: 'Vietnam', native: 'Việt Nam', emoji: '🇻🇳', tel: '84' },
  { code: 'WF', name: 'Wallis and Futuna', native: null, emoji: '🇼🇫', tel: '681' },
  { code: 'EH', name: 'Western Sahara', native: '‫الصحراء الغربية‬‎', emoji: '🇪🇭', tel: '212' },
  { code: 'YE', name: 'Yemen', native: '‫اليمن‬‎', emoji: '🇾🇪', tel: '967' },
  { code: 'ZM', name: 'Zambia', native: null, emoji: '🇿🇲', tel: '260' },
  { code: 'ZW', name: 'Zimbabwe', native: null, emoji: '🇿🇼', tel: '263' },
  { code: 'AX', name: 'Åland Islands', native: null, emoji: '🇦🇽', tel: '358' }
];



// WEBPACK FOOTER //
// ./src/constants/countries.js